import { useMemo } from 'react'

import { PAYMENT_PROVIDERS } from '@constants/paymentProviders'
import { useOxxo } from '@pages/Checkout/hooks/Payment/Common/useOxxo'
import { useCard } from '@pages/Checkout/hooks/Payment/dLocal/useCard'
import { useMercadoPago } from '@pages/Checkout/hooks/Payment/dLocal/useMercadoPago'

export const useDLocalMethods = () => {
  const creditCard = useCard()
  const ox = useOxxo({ provider: PAYMENT_PROVIDERS.DLOCAL })
  const mercadoPago = useMercadoPago()

  return useMemo(
    () => ({
      creditCard,
      ox,
      mp: mercadoPago,
    }),
    [creditCard, ox, mercadoPago],
  )
}
